import { render, staticRenderFns } from "./OpzstatItemsIndex.vue?vue&type=template&id=6ec41c46&scoped=true"
import script from "./OpzstatItemsIndex.vue?vue&type=script&lang=js"
export * from "./OpzstatItemsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec41c46",
  null
  
)

export default component.exports